import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetChatIsTyping($chatId: ID!) {
    chat(id: $chatId) {
      id
      user {
        id
        name
        phone
      }
      expert {
        id
        name
        photoUrl
      }
      expertIsTyping
      userIsTyping
    }
  }
`);
